const ExpertList = () => import('Views/expert/expert-list');
const ExpertDetail = () => import('Views/expert/expert-detail');

export default[
  { path: '/expert-list', component: ExpertList },
  { path: '/expert-detail/:id', component: ExpertDetail },
];



// WEBPACK FOOTER //
// ./src/router/expert.js